import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { MCGRATH_META } from "./meta.ts";
import { buildSearchUrl } from "./runtime.ts";

export * from "./meta.ts";
export * from "./runtime.ts";

// McGrath returns HTTP 429 to direct + Firecrawl-stealth requests (Akamai
// bot wall). The Bright Data Web Unlocker zone that breaks REA + Domain
// works for McGrath too — zones are service plans, not host-locked. But
// McGrath's `/buy` is a Next.js catch-all that hydrates listings via XHR
// (see docs/scraper-routing.md), so Web Unlocker's `format=raw` returns
// only the SSR shell. The Scraping Browser zone drives a real Chromium
// over CDP/WSS so the page can hydrate before we capture HTML.
export const MCGRATH_ADAPTER = defineSoldOnlyAdapter(MCGRATH_META, buildSearchUrl, {
  brightdataDiscoveryFirst: true,
  brightdataBrowserZoneEnvVar: "BRIGHTDATA_SPA_BROWSER_WSS_URL",
});
